<div  class="adv-2" >
    <div class="row">
        <div class="col-sm-8">
            <img src="assets/images/supplier_central.svg" alt="Moglix Supplier">
            <h3>Wide Range of Brands</h3>
            <p class="text-white">All the major brands in each raw material category</p>
        </div>
        <div class="col-sm-4 d-flex align-items-center justify-content-end">
            <a class="know-more-btn" href="https://supplier.moglix.com/?utm_source=tendershark&utm_medium=homepage&utm_campaign=promotion" target="_blank">
                <span > Become A Supplier</span>
            </a>
        </div>
    </div>
</div>